import React from 'react';
import PropTypes from 'prop-types';
import { MEASURE_NAMES, SKILL_NAMES } from '../../../constants/assessments';
import { trcResultType } from '../../../constants/prop-types';
import TRCDetails from '../trc-details/TRCDetails';
import { localize, localizeDate } from '../../../common/localization';

const skillName = SKILL_NAMES.TEXT_READING_COMPREHENSION;

const TRCPMResultRow = ({ result, displayOfficialnessPopup }) => {
    const scoreInfo = result.results[0];
    return (
        <div key={`${scoreInfo.id}-${skillName}-row`} className='dashboard-measure-info'>
            <div className='dashboard-skill'>
                <span className='dashboard-skill-name'>{localize(skillName)}</span>
                <span className='dashboard-measure-name'>{localize(MEASURE_NAMES.TRC)}</span>
            </div>
            <div className='dashboard-form'>{scoreInfo.ccTrcLevel}</div>
            <div className='dashboard-window-dates'>{localizeDate(result.clientModDate)}</div>
            <TRCDetails
                overallPerf={scoreInfo.overallPerf}
                key={`${scoreInfo.id}-${skillName}-score`}
                accessLink={result.accessLink}
                displayOfficialnessPopup={displayOfficialnessPopup}
            />
        </div>
    );
};

TRCPMResultRow.defaultProps = {
    displayOfficialnessPopup: null,
};

TRCPMResultRow.propTypes = {
    result: trcResultType.isRequired,
    displayOfficialnessPopup: PropTypes.func,
};

export default TRCPMResultRow;
